
export const languageList = [
  {
    label: 'Afrikaans',
    value: 'af',
  },
  {
    label: 'Akan',
    value: 'ak',
  },
  {
    label: 'Albanian',
    value: 'sq',
  },
  {
    label: 'Amharic',
    value: 'am',
  },
  {
    label: 'Arabic',
    value: 'ar',
  },
  {
    label: 'Arabic (Kuwait)',
    value: 'ar-KW',
  },
  {
    label: 'Arabic (Morocco)',
    value: 'ar-MA',
  },
  {
    label: 'Arabic (Saudi Arabia)',
    value: 'ar-SA',
  },
  {
    label: 'Armenian',
    value: 'hy',
  },
  {
    label: 'Assamese',
    value: 'as',
  },
  {
    label: 'Azerbaijani',
    value: 'az',
  },
  {
    label: 'Balarusion',
    value: 'be',
  },
  {
    label: 'Bambara',
    value: 'bm',
  },
  {
    label: 'Basque',
    value: 'eu',
  },
  {
    label: 'Bengali',
    value: 'bn',
  },
  {
    label: 'Bosnian',
    value: 'bs',
  },
  {
    label: 'Breton',
    value: 'br',
  },
  {
    label: 'Bulgarian',
    value: 'bg',
  },
  {
    label: 'Burmese',
    value: 'my',
  },
  {
    label: 'Cambodian',
    value: 'km',
  },
  {
    label: 'Catalan',
    value: 'ca',
  },
  {
    label: 'Central Atlas Tamazight',
    value: 'tzm',
  },
  {
    label: 'Central Kurdish',
    value: 'ckb',
  },
  {
    label: 'Chechen',
    value: 'ce',
  },
  {
    label: 'Chinese (China)',
    value: 'zh-CN',
  },
  {
    label: 'Chinese (Hong Kong)',
    value: 'zh-HK',
  },
  {
    label: 'Chinese (Taiwan)',
    value: 'zh-TW',
  },
  {
    label: 'Cornish',
    value: 'kw',
  },
  {
    label: 'Croatian',
    value: 'hr',
  },
  {
    label: 'Czech',
    value: 'cs',
  },
  {
    label: 'Danish',
    value: 'da',
  },
  {
    label: 'Dutch',
    value: 'nl',
  },
  {
    label: 'Dutch (Belgium)',
    value: 'nl-BE',
  },
  {
    label: 'Dzongkha',
    value: 'dz',
  },
  {
    label: 'English (Australia)',
    value: 'en-AU',
  },
  {
    label: 'English (Canada)',
    value: 'en-CA',
  },
  {
    label: 'English (Ireland)',
    value: 'en-IE',
  },
  {
    label: 'English (New Zealand)',
    value: 'en-NZ',
  },
  {
    label: 'English (United Kingdom)',
    value: 'en-GB',
  },
  {
    label: 'English (United States)',
    value: 'en',
  },
  {
    label: 'Esperanto',
    value: 'eo',
  },
  {
    label: 'Estonian',
    value: 'et',
  },
  {
    label: 'Ewe',
    value: 'ee',
  },
  {
    label: 'Faroese',
    value: 'fo',
  },
  {
    label: 'Filipino',
    value: 'fil',
  },
  {
    label: 'Finnish',
    value: 'fi',
  },
  {
    label: 'French',
    value: 'fr',
  },
  {
    label: 'French (Canada)',
    value: 'fr-CA',
  },
  {
    label: 'French (Switzerland)',
    value: 'fr-CH',
  },
  {
    label: 'Frisian',
    value: 'fy',
  },
  {
    label: 'Fulah',
    value: 'ff',
  },
  {
    label: 'Galician',
    value: 'gl',
  },
  {
    label: 'Ganda',
    value: 'lg',
  },
  {
    label: 'Georgian',
    value: 'ka',
  },
  {
    label: 'German',
    value: 'de',
  },
  {
    label: 'German (Austria)',
    value: 'de-AT',
  },
  {
    label: 'German (Switzerland)',
    value: 'de-CH',
  },
  {
    label: 'Greek',
    value: 'el',
  },
  {
    label: 'Gujarati',
    value: 'gu',
  },
  {
    label: 'Hausa',
    value: 'ha',
  },
  {
    label: 'Hebrew',
    value: 'he',
  },
  {
    label: 'Hindi',
    value: 'hi',
  },
  {
    label: 'Hungarian',
    value: 'hu',
  },
  {
    label: 'Icelandic',
    value: 'is',
  },
  {
    label: 'Igbo',
    value: 'ig',
  },
  {
    label: 'Indonesian',
    value: 'id',
  },
  {
    label: 'Interlingua',
    value: 'ia',
  },
  {
    label: 'Irsh or Irish Gaelic',
    value: 'ga',
  },
  {
    label: 'Italian',
    value: 'it',
  },
  {
    label: 'Italian (Switzerland)',
    value: 'it-CH',
  },
  {
    label: 'Japanese',
    value: 'ja',
  },
  {
    label: 'Javanese',
    value: 'jv',
  },
  {
    label: 'Kalaallisut',
    value: 'kl',
  },
  {
    label: 'Kannada',
    value: 'kn',
  },
  {
    label: 'Kashmiri',
    value: 'ks',
  },
  {
    label: 'Kazakh',
    value: 'kk',
  },
  {
    label: 'Kikuyu',
    value: 'ki',
  },
  {
    label: 'Kinyarwanda',
    value: 'rw',
  },
  {
    label: 'Korean',
    value: 'ko',
  },
  {
    label: 'Kurdish',
    value: 'ku',
  },
  {
    label: 'Kyrgyz',
    value: 'ky',
  },
  {
    label: 'Lao',
    value: 'lo',
  },
  {
    label: 'Latvian',
    value: 'lv',
  },
  {
    label: 'Lingala',
    value: 'ln',
  },
  {
    label: 'Lithuanian',
    value: 'lt',
  },
  {
    label: 'Luba-Katanga',
    value: 'lu',
  },
  {
    label: 'Luxembourgish',
    value: 'lb',
  },
  {
    label: 'Macedonian',
    value: 'mk',
  },
  {
    label: 'Malagasy',
    value: 'mg',
  },
  {
    label: 'Malay',
    value: 'ms',
  },
  {
    label: 'Malayalam',
    value: 'ml',
  },
  {
    label: 'Maltese (Malta)',
    value: 'mt',
  },
  {
    label: 'Manx',
    value: 'gv',
  },
  {
    label: 'Maori',
    value: 'mi',
  },
  {
    label: 'Marathi',
    value: 'mr',
  },
  {
    label: 'Mongolian',
    value: 'mn',
  },
  {
    label: 'Nepalese',
    value: 'ne',
  },
  {
    label: 'North Ndebele',
    value: 'nd',
  },
  {
    label: 'Northern Sami',
    value: 'se',
  },
  {
    label: 'Norwegian',
    value: 'no',
  },
  {
    label: 'Norwegian BokmÃ¥l',
    value: 'nb',
  },
  {
    label: 'Nynorsk',
    value: 'nn',
  },
  {
    label: 'Odia',
    value: 'or',
  },
  {
    label: 'Oromo',
    value: 'om',
  },
  {
    label: 'Ossetic',
    value: 'os',
  },
  {
    label: 'Pashto',
    value: 'ps',
  },
  {
    label: 'Persian',
    value: 'fa',
  },
  {
    label: 'Polish',
    value: 'pl',
  },
  {
    label: 'Portuguese',
    value: 'pt',
  },
  {
    label: 'Portuguese (Brazil)',
    value: 'pt-BR',
  },
  {
    label: 'Portuguese (Portugal)',
    value: 'pt-PT',
  },
  {
    label: 'Punjabi',
    value: 'pa',
  },
  {
    label: 'Quechua',
    value: 'qu',
  },
  {
    label: 'Romanian',
    value: 'ro',
  },
  {
    label: 'Romansh',
    value: 'rm',
  },
  {
    label: 'Rundi',
    value: 'rn',
  },
  {
    label: 'Russian',
    value: 'ru',
  },
  {
    label: 'Sango',
    value: 'sg',
  },
  {
    label: 'Sanskrit',
    value: 'sa',
  },
  {
    label: 'Sardinian',
    value: 'sc',
  },
  {
    label: 'Scottish Gealic',
    value: 'gd',
  },
  {
    label: 'Serbian',
    value: 'sr',
  },
  {
    label: 'Shona',
    value: 'sn',
  },
  {
    label: 'Sichuan Yi',
    value: 'ii',
  },
  {
    label: 'Sindhi',
    value: 'sd',
  },
  {
    label: 'Sinhalese',
    value: 'si',
  },
  {
    label: 'Slovak',
    value: 'sk',
  },
  {
    label: 'Slovenian',
    value: 'sl',
  },
  {
    label: 'Somali',
    value: 'so',
  },
  {
    label: 'Spanish',
    value: 'es',
  },
  {
    label: 'Spanish (Dominican Republic)',
    value: 'es-DO',
  },
  {
    label: 'Spanish (United States)',
    value: 'es-US',
  },
  {
    label: 'Sundanese',
    value: 'su',
  },
  {
    label: 'Swahili',
    value: 'sw',
  },
  {
    label: 'Swedish',
    value: 'sv',
  },
  {
    label: 'Tajik',
    value: 'tg',
  },
  {
    label: 'Tamil',
    value: 'ta',
  },
  {
    label: 'Tatar',
    value: 'tt',
  },
  {
    label: 'Telugu',
    value: 'te',
  },
  {
    label: 'Thai',
    value: 'th',
  },
  {
    label: 'Tibetan',
    value: 'bo',
  },
  {
    label: 'Tigrinya',
    value: 'ti',
  },
  {
    label: 'Tongan',
    value: 'to',
  },
  {
    label: 'Turkish',
    value: 'tr',
  },
  {
    label: 'Turkmen',
    value: 'tk',
  },
  {
    label: 'Ukrainian',
    value: 'uk',
  },
  {
    label: 'Urdu',
    value: 'ur',
  },
  {
    label: 'Uyghur',
    value: 'ug',
  },
  {
    label: 'Uzbek',
    value: 'uz',
  },
  {
    label: 'Vietnamese',
    value: 'vi',
  },
  {
    label: 'Welsh',
    value: 'cy',
  },
  {
    label: 'Wolof',
    value: 'wo',
  },
  {
    label: 'Xhosa',
    value: 'xh',
  },
  {
    label: 'Yiddish',
    value: 'yi',
  },
  {
    label: 'Yoruba Nigeria',
    value: 'yo',
  },
  {
    label: 'Zulu',
    value: 'zu',
  },
];

export const languageToLocale: { [key: string]: string } = {
  "af": "af",
  "ak": "en-US",
  "sq": "sq",
  "am": "en-US",
  "ar": "ar",
  "ar-KW": "ar",
  "ar-MA": "ar-MA",
  "ar-SA": "ar-SA",
  "hy": "hy",
  "as": "en-US",
  "az": "az",
  "be": "be",
  "bm": "en-US",
  "eu": "eu",
  "bn": "bn",
  "bs": "bs",
  "br": "en-US",
  "bg": "bg",
  "my": "en-US",
  "km": "km",
  "ca": "ca",
  "tzm": "en-US",
  "ckb": "ckb",
  "ce": "en-US",
  "zh-CN": "zh-CN",
  "zh-HK": "zh-HK",
  "zh-TW": "zh-TW",
  "kw": "en-US",
  "hr": "hr",
  "cs": "cs",
  "da": "da",
  "nl": "nl",
  "nl-BE": "nl-BE",
  "dz": "en-US",
  "en-AU": "en-AU",
  "en-CA": "en-CA",
  "en-IE": "en-IE",
  "en-NZ": "en-NZ",
  "en-GB": "en-GB",
  "en": "en-US",
  "eo": "eo",
  "et": "et",
  "ee": "en-US",
  "fo": "en-US",
  "fil": "en-US",
  "fi": "fi",
  "fr": "fr",
  "fr-CA": "fr-CA",
  "fr-CH": "fr-CH",
  "fy": "fy",
  "ff": "en-US",
  "gl": "gl",
  "lg": "en-US",
  "ka": "ka",
  "de": "de",
  "de-AT": "de-AT",
  "de-CH": "de",
  "el": "el",
  "gu": "gu",
  "ha": "en-US",
  "he": "he",
  "hi": "hi",
  "hu": "hu",
  "is": "is",
  "ig": "en-US",
  "id": "id",
  "ia": "en-US",
  "ga": "en-US",
  "it": "it",
  "it-CH": "it-CH",
  "ja": "ja",
  "jv": "en-US",
  "kl": "en-US",
  "kn": "kn",
  "ks": "en-US",
  "kk": "kk",
  "ki": "en-US",
  "rw": "en-US",
  "ko": "ko",
  "ku": "en-US",
  "ky": "en-US",
  "lo": "en-US",
  "lv": "lv",
  "ln": "en-US",
  "lt": "lt",
  "lu": "en-US",
  "lb": "lb",
  "mk": "mk",
  "mg": "en-US",
  "ms": "ms",
  "ml": "en-US",
  "mt": "mt",
  "gv": "en-US",
  "mi": "en-US",
  "mr": "en-US",
  "mn": "mn",
  "ne": "en-US",
  "nd": "en-US",
  "se": "se",
  "no": "en-US",
  "nb": "nb",
  "nn": "nn",
  "or": "en-US",
  "om": "en-US",
  "os": "en-US",
  "ps": "en-US",
  "fa": "fa-IR",
  "pl": "pl",
  "pt": "pt",
  "pt-BR": "pt-BR",
  "pt-PT": "pt-PT",
  "pa": "en-US",
  "qu": "en-US",
  "ro": "ro",
  "rm": "en-US",
  "rn": "en-US",
  "ru": "ru",
  "sg": "en-US",
  "sa": "en-US",
  "sc": "en-US",
  "sr": "sr",
  "sn": "en-US",
  "sd": "en-US",
  "si": "en-US",
  "sk": "sk",
  "sl": "sl",
  "so": "en-US",
  "gd": "gd",
  "ii": "en-US",
  "es": "es",
  "es-DO": "es",
  "es-US": "es",
  "su": "en-US",
  "sw": "en-US",
  "sv": "sv",
  "tg": "en-US",
  "ta": "ta",
  "tt": "en-US",
  "te": "te",
  "th": "th",
  "bo": "en-US",
  "ti": "en-US",
  "to": "en-US",
  "tr": "tr",
  "tk": "en-US",
  "uk": "uk",
  "ur": "en-US",
  "ug": "ug",
  "uz": "uz",
  "vi": "vi",
  "cy": "cy",
  "wo": "en-US",
  "xh": "en-US",
  "yi": "en-US",
  "yo": "en-US",
  "zu": "en-US"
};

export const languageSupportCheckout = {
  // 'ar': ['ar', 'ar-KW', 'ar-MA'], // Arabic
  // 'ar-KW': ['ar', 'ar-KW', 'ar-MA'], // Arabic (Kuwait)
  // 'ar-MA': ['ar', 'ar-KW', 'ar-MA'], // Arabic (Morocco)
  // 'ar-SA': ['ar', 'ar-KW', 'ar-SA'], // Arabic (Saudi Arabia)

  'ar': ['ar', 'ar-KW', 'ar-MA'], // Arabic
  'ar-KW': ['ar', 'ar-KW', 'ar-MA'], // Arabic (Kuwait)
  'ar-MA': ['ar', 'ar-KW', 'ar-MA'], // Arabic (Morocco)
  'ar-SA': ['ar', 'ar-KW', 'ar-MA'], // Arabic (Saudi Arabia)

  'zh-CN': ['zh-CN', 'zh-HK', 'zh-TW'], // Chinese
  'zh-HK': ['zh-CN', 'zh-HK', 'zh-TW'], // Chinese (Hong Kong)
  'zh-TW': ['zh-CN', 'zh-HK', 'zh-TW'], // Chinese (Taiwan)

  'en': ['en.default', 'en-AU', 'en-CA'], // English
  'en-AU': ['en.default', 'en-AU', 'en-CA'], // English (Australia)
  'en-CA': ['en.default', 'en-AU', 'en-CA'], // English (Canada)
  'en-IE': ['en.default', 'en-AU', 'en-CA'], // English (Ireland)
  'en-NZ': ['en.default', 'en-AU', 'en-CA'], // English (New Zealand)
  'en-GB': ['en.default', 'en-AU', 'en-CA'], // English (United Kingdom)

  'fr': ['fr', 'fr-CA', 'fr-CH'], // French
  'fr-CA': ['fr', 'fr-CA', 'fr-CH'], // French (Canada)
  'fr-CH': ['fr', 'fr-CA', 'fr-CH'], // French (Switzerland)

  'de': ['de', 'de-AT', 'de-CH'], // German
  'de-AT': ['de', 'de-AT', 'de-CH'], // German (Austria)
  'de-CH': ['de', 'de-AT', 'de-CH'], // German (Switzerland)

  'pt': ['pt', 'pt-BR', 'pt-PT'], // Portuguese
  'pt-BR': ['pt', 'pt-BR', 'pt-PT'], // Portuguese (Brazil)
  'pt-PT': ['pt', 'pt-BR', 'pt-PT'], // Portuguese (Portugal)

  'es': ['es', 'es-DO', 'es-US'], // Spanish
  'es-DO': ['es', 'es-DO', 'es-US'], // Spanish (Dominican Republic)
  'es-US': ['es', 'es-DO', 'es-US'], // Spanish (United States)
};

export const DEFAULT_PICKUP_TEXT = {
  headerTitle: 'Pick a delivery date that works best for you',
  labelAndButtons: {
    buttonLabel: 'Store pickup',
    instructions: 'Choose the nearest location for your pickup',
    dateTitle: 'Pickup date ',
    timeTitle: 'Pickup time ',
    captionDateTitle: 'Pickup date',
    captionTimeTitle: 'Pickup time',
  },
  isShowMessageMinimum: false,
  isUseAdditionalNote: false,
  requiredConditions: {
    // requiredMessage: 'Please choose a pickup date and time before checkout',
    beforeCheckout: 'Please choose a pickup date and time before checkout',
    beforeAddToCart: 'Please choose a pickup date and time',
  },
  errorMessages: {
    // fontSize: 14,
    eligibleMessage: "Unfortunately, pickup isn't available for your selected items",
  },
  additionalMessages: {
    minimumOrderValue: '',
    minimumOrderWeight: '',
  },
  orderStatusMessage: {
    heading: 'Pickup details',
    location: 'Pickup address',
    selectedDate: 'Pickup date',
    selectedTime: 'Pickup time',
  },
};

export const DEFAULT_DELIVERY_TEXT = {
  headerTitle: 'Pick a delivery date that works best for you',

  labelAndButtons: {
    buttonLabel: 'Local delivery',
    instructions: 'Enter your zip or postal code and tap check for local delivery',
    zipCodeLabel: 'Postal code',
    checkButton: 'Check',
    dateTitle: 'Local delivery date',
    timeTitle: 'Local delivery time',
    captionDateTitle: 'Local delivery date',
    captionTimeTitle: 'Local delivery time',
  },
  isShowMessageMinimum: false,
  isUseAdditionalNote: false,
  requiredConditions: {
    // requiredMessage: 'Please choose a delivery date and time before checkout',
    beforeCheckout: 'Please choose a pickup date and time before checkout',
    beforeAddToCart: 'Please choose a pickup date and time',
    eligibleNotice: 'Local delivery is available in your area',
  },
  errorMessages: {
    // fontSize: 14,
    eligibleMessage: "Unfortunately, local delivery isn't available for your selected items",
    notSupportedZone: 'Sorry, your area is not supported for delivery',
  },
  additionalMessages: {
    minimumOrderValue: '',
    minimumOrderWeight: '',
  },
  orderStatusMessage: {
    heading: 'Delivery details',
    location: 'Delivery address',
    selectedDate: 'Delivery date',
    selectedTime: 'Delivery time',
  },
};

export const DEFAULT_SHIPPING_TEXT = {
  headerTitle: 'Pick a delivery date that works best for you',
  labelAndButtons: {
    buttonLabel: 'Shipping',
    dateTitle: 'Shipping date',
    timeTitle: 'Shipping time',
    captionDateTitle: 'Shipping date',
    captionTimeTitle: 'Shipping time',
  },
  isShowMessageMinimum: false,
  isUseAdditionalNote: false,
  requiredConditions: {
    // requiredMessage: 'Please choose a shipping date and time before checkout',
    beforeCheckout: 'Please choose a pickup date and time before checkout',
    beforeAddToCart: 'Please choose a pickup date and time',
  },
  errorMessages: {
    // fontSize: 14,
    eligibleMessage: "Unfortunately, shipping isn't available for your selected items",
  },
  additionalMessages: {
    minimumOrderValue: '',
    minimumOrderWeight: '',
    additionalNotesLabel: 'Notes',
  },
  orderStatusMessage: {
    heading: 'Shipping details',
    location: 'Shipping address',
    selectedDate: 'Shipping date',
    selectedTime: 'Shipping time',
  },
};